module.exports = __webpack_public_path__ + "static/media/mercearia-2.78a528b4.jpg";